import { I18n } from '@/i18n/I18n';
import { useState } from 'react';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ConfirmModal } from '../modals/ConfirmModal';

export function DeleteItem(props: {
  deleteAction: () => Promise<unknown>,
  itemType: string,
  title: string,
  disabled?: boolean,
  disabledMessage?: string,
}) {
  const { deleteAction, itemType, title, disabled, disabledMessage } = props;
  const [showModal, setShowModal] = useState(false);
  const model = I18n.get(itemType);

  const confirmMessage = title ? I18n.get('areYouSure', { model, title }) : I18n.get('areYouSureNoTitle', { model });

  return (
    <>
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={disabled ? <Tooltip>{disabledMessage}</Tooltip> : <div/>}
      >
        <div>
          <Dropdown.Item
            className={`${disabled ? 'text-muted' : 'text-danger'}`}
            onClick={() => setShowModal(true)}
            disabled={disabled}
          >
            <div className={disabled ? 'text-secondary' : ''}>
              {I18n.get('delete')}
            </div>
          </Dropdown.Item>
        </div>
      </OverlayTrigger>
      {showModal && (
        <ConfirmModal
          title={I18n.get('delete')}
          confirmMessage={confirmMessage}
          onConfirm={deleteAction}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
}
